import React from 'react'
import { FormattedMessage } from 'react-intl'

import {
  CredibilitySection,
  CredibilityViewport,
  CredibilityTrack,
  CredibilityInner,
  CredibilityItem,
  CredibilityDot
} from './CredibilityStyledComponents'

const CREDIBILITY_IDS = [
  'homepage.credibility.founded',
  'homepage.credibility.location',
  'homepage.credibility.liveWith',
  'homepage.credibility.shopify',
  'homepage.credibility.enterprise'
]

const Credibility = () => (
  <CredibilitySection>
    <CredibilityViewport>
      <CredibilityTrack>
        {[0, 1].map(copy => (
          <CredibilityInner key={copy} aria-hidden={copy === 1 || undefined}>
            {CREDIBILITY_IDS.map(id => (
              <React.Fragment key={`${copy}-${id}`}>
                <CredibilityItem>
                  <FormattedMessage id={id} />
                </CredibilityItem>
                <CredibilityDot aria-hidden="true" />
              </React.Fragment>
            ))}
          </CredibilityInner>
        ))}
      </CredibilityTrack>
    </CredibilityViewport>
  </CredibilitySection>
)

Credibility.displayName = 'Credibility'

export default Credibility
